var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2303 3L13.8817 4.35046L7.48165 8.04954L5.13303 9.4V22.2L7.48165 23.5505L13.9404 27.2495L16.289 28.6L18.6376 27.2495L24.9789 23.5505L27.3275 22.2V9.4L24.9789 8.04954L18.5789 4.35046L16.2303 3ZM9.83028 19.4991V12.1009L16.2303 8.40183L22.6303 12.1009V19.4991L16.2303 23.1982L9.83028 19.4991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/LINK.1d91c071e216f781f10e64b527753ba8.svg";
export { ForwardRef as ReactComponent };